import { useState } from 'react';
import { ControlService } from '../../types';
import { PERCENTAGE_START_POINT } from '../constants';
import { findSharedStylesNumericValue } from '../processValues/readers';
import {
  updateStylesProportionally,
  updateStylesWithSameValue,
} from '../processValues/updaters';

export function usePropotionalControl({
  service,
  styleIds,
}: {
  service: ControlService;
  styleIds: string[];
}): {
  getControl: ControlService['getControl'];
  controlValue: number;
  updateControl: (newValue: number) => void;
  percentageMode: boolean;
} {
  const sharedValue = findSharedStylesNumericValue(
    service.styles,
    service.styleDefinitions,
    styleIds,
  );

  const isPercentageMode = sharedValue === undefined;
  const initialValue = isPercentageMode ? PERCENTAGE_START_POINT : sharedValue;

  const [controlValue, setControlValue] = useState(initialValue);

  const updateControl = (newValue: number) => {
    setControlValue(newValue);

    const updatedStyles = isPercentageMode
      ? updateStylesProportionally(
          newValue,
          service.styles,
          service.styleDefinitions,
          styleIds,
        )
      : updateStylesWithSameValue(
          newValue,
          styleIds,
          service.styles,
          service.styleDefinitions,
        );

    return service.setStyles(updatedStyles);
  };

  return {
    getControl: service.getControl,
    controlValue,
    percentageMode: isPercentageMode,
    updateControl,
  };
}
